<template>
  <div id="app">
    <headers></headers>
    <div class="teaching-list">
      <div class="w_1400">
        <div class="previous-page">
          <a href="javascript:history.back(-1)"><i class="el-icon-arrow-left" style="color: #fff;font-size: 30px;"></i></a>
        </div>

        <div class="teaching-list-left">
          <div class="teaching-list-user" v-if="userinfo">
            <p>
              <el-upload class="avatar-uploader" :headers="{token}" :action="baseUrl+'teacher/common/upload'"
                :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                <img :src="form.avatar" alt="">
                <span class="editimg"><i class="iconfont icon-a-Vector2" style="color:#fff"></i></span>
              </el-upload>
            </p>
            <h1>{{userinfo.nickname}}</h1>
          </div>

          <div class="teaching-list-nav">
            <h3>我的教学</h3>
            <ul style="margin-top: 8px;">
              <li :class="active==1?'active':''" @click="active=1">
                <span>基础信息</span>
              </li>
              <!-- <li :class="active==2?'active':''" @click="active=2">
                <span>修改密码</span>
              </li> -->
              <li :class="active==3?'active':''" @click="active=3">
                <span>更改手机号</span>
              </li>
              <li :class="active==4?'active':''" @click="active=4">
                <span>账户绑定</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="teaching-list-right">
          <h3>个人信息</h3>

          <div class="teaching-list-table homework-table active1" v-if="form&&active==1">
            <div style="text-align: center;">
              <el-upload class="avatar-uploader" :headers="{token}" :action="baseUrl+'teacher/common/upload'"
                :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                <img v-if="form.avatar" :src="form.avatar" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
            <el-form label-position="top" label-width="80px" :model="formLabelAlign">
              <el-form-item label="真实姓名">
                <el-input v-model="form.nickname" placeholder="请输入真实姓名（ 仅自己可见）"></el-input>
              </el-form-item>
              <el-form-item label="地址">
                <el-input v-model="form.address" placeholder="请输入地址（实体教材会给您发送快递使用 ）"></el-input>
              </el-form-item>
              <el-form-item label="QQ">
                <el-input v-model="form.qq" placeholder="请输入QQ号"></el-input>
              </el-form-item>
              <el-form-item label="性别">
                <el-radio-group v-model="form.gender" :fill="'#22AC38'">
                  <el-radio :label="1">男</el-radio>
                  <el-radio :label="2">女</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="个人简介">
                <el-input v-model="form.introduce" placeholder="写一段话让同学们更了解你吧"></el-input>
              </el-form-item>
              <!-- <el-form-item label="QQ">
                <el-input v-model="userinfo.avatar"></el-input>
              </el-form-item> -->
              <div style="width: 100%;text-align: center;">
                <el-button type="success" round
                  style="background: #22AC38 !important;width: 240px;display: inline-block;margin: 0 auto;height: 48px !important;border-radius: 200px;"
                  @click="subuser()">
                  提交
                </el-button>
              </div>

            </el-form>
          </div>
          <div class="teaching-list-table homework-table active2" v-else-if="active==3">
            <div class="loginformsss">
            	<div class="left">
            		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            			<el-form-item prop="name">
            				<el-input v-model="ruleForm.name" placeholder="请输入新手机号码"></el-input>
            			</el-form-item>

                  <el-form-item>
                    <div style="display: inline-block;width: 69%;"><el-input v-model="ruleForm.smscode" type="string" placeholder="请输入验证码"></el-input></div>
                    <div class="smsbtn" @click="getsms()">{{smstext}}</div>
                  </el-form-item>
                  <el-form-item>
                    <div class="loginbtn" @click="login()">更改手机号</div>
                  </el-form-item>
            		</el-form>
            	</div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>

<script>
  import headers from '../../components/headers.vue';
  import footers from '../../components/footers.vue';
  import axios from 'axios';
  import {
    profile,
    sendsms,
    changemobile
  } from '../../request/api';

  export default {
    name: 'app',
    components: {
      headers,
      footers
    },
    data() {
      return {
        userinfo: '',
        imageUrl: '',
        baseUrl: '',
        labelPosition: 'right',
        formLabelAlign: {
          name: '',
          region: '',
          type: ''
        },
        form: '',
        active: 1,
        ruleForm: {
          name: '',
          region: ''
        },
        rules: {
          name: [{
            required: true,
            message: '请输入登录账号',
            trigger: 'blur'
          }],
          region: [{
            required: true,
            message: '请输入登录密码',
            trigger: 'blur'
          }]
        },
        smstext: '获取验证码',
        isclick: true,
      }
    },
    methods: {
      handleAvatarSuccess(res, file) {
        console.log(res, file)
        // this.imageUrl = URL.createObjectURL(file.raw);
        this.form.avatar = res.data.fullurl
        this.profile()
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      subuser() {
        profile(this.form).then(res => {
          // localStorage.setItem('userinfo',res.data)
          if(res.code){
            this.userinfo.nickname=res.data.nickname
            localStorage.setItem('userinfo',JSON.stringify(this.userinfo))
            location.reload();
          }
          this.$message({
            message: res.msg,
            type: 'error'
          });
        })
      },
      // 登录方法
      login() {
        changemobile({
          'mobile': this.ruleForm.name,
          'captcha': this.ruleForm.smscode
        }).then(res => {
          if (res.code) {
            localStorage.clear();
            this.$message.success(res.msg);
            setTimeout(()=>{
              location.reload();
            },1500)
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      // 发送验证码
      getsms() {
        sendsms({
          'mobile': this.ruleForm.name,
          'event': 'changemobile'
        }).then(res => {
          //判断是否发送成功
          if (res.code) {
            //判断用户是否点击发送过了
            if (this.isclick) {
              this.isclick = false
              //计时器，设置60秒后允许用户再次点击
              let time = 60
              let self = this
              this.$message.success("获取成功")
              self.smstext = time + 's后重新获取';
              let interval = setInterval(() => {
                // console.log("10000", time)
                time--
                if (time >= 0) {
                  self.smstext = time + 's后重新获取';
                } else {
                  self.isclick = true
                  self.smstext = '重新获取';
                }
              }, 1000)
            } else {
              this.$message.error(this.smstext);
            }
          } else {
            this.$message.error(res.msg);
          }
        })
      }

    },
    created() {
      this.token = localStorage.getItem('token')
      this.baseUrl = axios.defaults.baseURL
      // this.allcourses();
      this.userinfo = JSON.parse(localStorage.getItem('userinfo'));
      // this.form.avatar = this.userinfo.avatar
      // this.form.nickname = this.userinfo.nickname
      profile({}).then(res => {
        // localStorage.setItem('userinfo',res.data)
        this.form = res.data
      })
      // this.form.address=this.userinfo.address?this.userinfo.address:''
      // this.form.gender=this.userinfo.gender?
      // this.form.qq=this.userinfo.qq
      // this.form.introduc=this.userinfo.introduc
    }
  }
</script>

<style>
  @import '../../assets/css/home.css';

  .el-button--small {
    width: 99.86px;
    height: 28.04px;
    background: #80D676;
    border-radius: 3.116px;
    color: #FDFDFD;
  }

  .el-input {
    width: 330px;
  }

  .el-input-group--prepend .el-input__inner {
    border: none;
  }

  .input-with-select .el-input-group__prepend {
    border: none;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .active1 .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .active1 .el-radio__input.is-checked .el-radio__inner {
    border-color: #22AC38;
    background: #22AC38;
  }

  .active1 .el-radio__input.is-checked+.el-radio__label {
    color: #78828A;
  }

  .active1 .el-input__inner {
    border: none;
    background: transparent;
  }

  .active1 .el-form-item__content {
    width: 100%;
    height: 52px;
    line-height: 52px;

    background: #ECF1F6;
    border-radius: 4px;
  }

  .active1 .el-radio-group {
    margin-left: 20px;
  }
  .active2{
    /* text-align: center; */
  }
  .active2 .el-form-item__content {
    margin-left: 0px !important;
  }




  .loginformsss {
  	width: 700px;
  	margin: 0 auto;
  	overflow: hidden;
    background: #FFFFFF;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    padding-top: 36px;
    text-align: center;
  }

  .loginformsss .left {
  	width: 700px;
  	height: auto;
  }

  .active2 .el-form {
  	width: 600px;
  	align-self: center;
  	margin: 0 auto;
  }

  .loginformsss .title {
  	font-weight: 400;
  	font-size: 25.875px;
  	line-height: 36px;
  	color: #0A1633;
    margin-bottom: 18px;
    display: block;
  }

  .loginformsss .right {
  	float: left;
  	width: 338.5px;
  	height: auto;
  	display: flex;
  }
  .loginformsss .right div{
  	margin: 0 auto;
  	align-self: center;
  }

  .el-form-item__content {
  	margin-left: 0px !important;
  }

  .loginformsss .left .el-input__inner{
    height: 58px !important;
    line-height: 58px !important;
    background: #FAFAFC;
    box-shadow: 0px 5px 12px 0px rgba(0,0,0,0.05);
    border-radius: 12px 12px 12px 12px;
    opacity: 1;
    border: 2px solid #E3E9ED;
  }

  .subtitle{font-size: 20px;font-weight: 600;color: #526075;line-height: 21px;}

  .reload{
  	font-size: 20px;
  	font-weight: 400;
  	color: #526075;
  	line-height: 21px;
  }

  .smslogin{
    width: 100%;
    height: 64px;
    line-height: 64px;
    background: #EEF5EF;
    border-radius: 500px 500px 500px 500px;
    cursor:pointer
  }

  .loginbtn{
    width: 100%;
    height: 60px;
    line-height: 60px;
    background: #22AC38;
    border-radius: 375px;
    color: #FDFDFD;
    font-weight: 700;
    font-size: 21px;
    cursor:pointer;
  }

  .smsbtn{
    display: inline-block;
    width: 25%;
    margin-left: 4%;
    height: 58px;
    line-height: 58px;

    background: #FAFAFC;
    /* Grayscale/Grayscale 30 */

    border: 1.125px solid #E3E9ED;
    box-shadow: 0px 3.375px 9px rgba(0, 0, 0, 0.05);
    border-radius: 9px;
    cursor:pointer;
  }
  .el-input{
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/personage.vue